import { render } from "./choose-user.vue?vue&type=template&id=0b37f2b1&scoped=true&ts=true"
import script from "./choose-user.vue?vue&type=script&lang=ts"
export * from "./choose-user.vue?vue&type=script&lang=ts"

import "./choose-user.vue?vue&type=style&index=0&id=0b37f2b1&lang=less&scoped=true"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b37f2b1"]])

export default __exports__